import { MobileCommLandmarkList } from "../MobileCommLandmarkList";
import { MobileCommLandmarkTools } from "../MobileCommLandmarkTools";
import { DataSource, Layout, Map, Panel, Splitter } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommLandmarkAndMapView extends Layout {
    googleMap: Map;
    layoutMobileCommLandmarkList: MobileCommLandmarkList;
    layoutMobileCommLandmarkTools: MobileCommLandmarkTools;
    noMap: Map;
    panelMapView: Panel;
    sourceMobileCommLandmark: DataSource;
    splitterTracking: Splitter;
    trimbleMap: Map;
}
